import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const setAllocationConstruction = async (card_volume_requirement: any) => {
  const token = getToken();
  let valid = false;
  let result;
  const params = {
    card_volume_requirement,
  };

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/card_sustainability_reports/set_card_allocation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
  };
};

export default setAllocationConstruction;
